import { useCherreValue } from '@cherre-frontend/data-fetching';
import {
  ConnectorEnvironments,
  useConnectorEnvironment,
} from 'src/hooks/useConnectorEnvironment';
import { connectorOverviewDemo } from 'src/services/ConnectorDemo/recoil';
import { useGetOverviewProd } from './useGetOverviewProd';
import { useGetOverviewProdReturn } from './useGetOverviewProd/model';
import { ConnectorStages } from 'src/products/connector/constants';

export const useGetOverview = (stage?: ConnectorStages) => {
  const environment = useConnectorEnvironment();

  if (environment === ConnectorEnvironments.MVP) {
    const {
      data: { connector, stagesStatuses },
    } = useGetOverviewProd(stage);
    return { connector, stagesStatuses };
  } else {
    const response = useCherreValue<useGetOverviewProdReturn>(
      connectorOverviewDemo as any
    ) as NonNullable<useGetOverviewProdReturn>;
    const {
      data: { connector, stagesStatuses },
    } = response.data as any;

    return { connector, stagesStatuses };
  }
};
